import React, { PureComponent } from 'react';
import { func } from 'prop-types';
import styled from 'styled-components';
import Button from '@material-ui/core/Button';
import { colors } from '../../../../../../../constants/colors';
import { fontFamily, fontSize } from '../../../../../../../constants/text';

const Root = styled.div.withConfig({ componentId: 'sc-upn6kz-0' })`
  padding: 22px 24px;
`;

const Title = styled.div.withConfig({ componentId: 'sc-upn6kz-1' })`
  font-family: ${fontFamily.bold};
  font-size: ${fontSize.large};
  color: ${colors.squid};
`;

const Logos = styled.div.withConfig({ componentId: 'sc-upn6kz-2' })`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
`;

const Disclaimer = styled.div.withConfig({ componentId: 'sc-upn6kz-3' })`
  font-size: ${fontSize.mediumSmall};
  font-family: ${fontFamily.book};
  color: ${colors.lightText};
`;

const OkayContainer = styled.div.withConfig({ componentId: 'sc-upn6kz-4' })`
  text-align: right;
`;

const Okay = styled(Button).withConfig({ componentId: 'sc-upn6kz-5' })`
  background-color: unset;
  font-family: ${fontFamily.medium};
  font-size: ${fontSize.mediumSmall};
  color: ${colors.blueJayWay};
  margin: 0 0 0 auto;
`;

type Props = {
  // @ts-expect-error ts-migrate(2749) FIXME: 'func' refers to a value, but is being used as a t... Remove this comment to see the full error message
  onClose?: func;
};

export default class Sources extends PureComponent<Props> {
  static MODAL_ID = 'health-checklist-sources';

  render = () => (
    <Root>
      <Title>Sources for guidelines</Title>

      <Logos>
        <img alt="American Optometric Association logo" src="/images/reminders/AOA.png" />

        <img alt="US Preventive Services logo" src="/images/reminders/US_preventive_services.png" />

        <img
          alt="Centers for Disease Control and Prevention logo"
          src="/images/reminders/cdc.png"
        />

        <img alt="American Academy of Family Physicians logo" src="/images/reminders/aafp.png" />

        <img alt="American Dental Association logo" src="/images/reminders/ada.png" />
      </Logos>

      <Disclaimer>
        NOTE: This checklist is for informational purposes only and is not intended to be a
        comprehensive list. Talk to your doctor to determine the best care plan for you.
      </Disclaimer>

      <OkayContainer>
        <Okay onClick={this.props.onClose}>OK</Okay>
      </OkayContainer>
    </Root>
  );
}
